module.exports = __webpack_public_path__ + "img/chinese-lantern.565c02a4.jpg";